export const toNullableString = (value: unknown): string | null | undefined => {
  if (typeof value === 'string') return value;
  if (value === null) return null;
  return undefined;
};

export const toNullableNumber = (value: unknown): number | null | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (value === null) return null;
  return undefined;
};

export const toNullableBoolean = (value: unknown): boolean | null | undefined => {
  if (typeof value === 'boolean') return value;
  if (value === null) return null;
  return undefined;
};
